import moment from 'moment';

export const formatDate = (date) => date.format('YYYY-MM-DDTHH:mm:ss');

export const calculateDate = (period) => {
  const now = moment().utc();
  now.set({ minute: 0, second: 0, millisecond: 0 });
  let startDate;

  switch (period) {
    case 'all':
      startDate = moment('2025-02-01');
      break;
    case 'ytd':
      startDate = moment().startOf('year');
      break;
    case 'qtd':
      startDate = moment().startOf('quarter');
      break;
    case 'mtd':
      startDate = moment().startOf('month');
      break;
    case '1w':
      startDate = now.clone().subtract(1, 'weeks');
      break;
    case '1m':
      startDate = now.clone().subtract(1, 'months');
      break;
    case '3m':
      startDate = now.clone().subtract(3, 'months');
      break;
    case '6m':
      startDate = now.clone().subtract(6, 'months');
      break;
    default:
      startDate = now;
      break;
  }

  return [startDate, now];
};

export function generateNaturalData(
  startDate,
  endDate,
  intervalHours,
  minValue,
  maxValue
) {
  const data = [];
  let currentTime = startDate.getTime();

  while (currentTime <= endDate.getTime()) {
    const randomValue = (
      Math.random() * (maxValue - minValue) +
      minValue
    ).toFixed(2); // 지정된 범위 내 랜덤 값
    data.push([currentTime, parseFloat(randomValue)]);
    currentTime += intervalHours * 60 * 60 * 1000; // 시간 간격 추가
  }

  return data;
}

export function generateHeatmapData(
  startDate,
  endDate,
  intervalHours,
  minValue,
  maxValue
) {
  const data = [];
  let currentTime = startDate.getTime();

  while (currentTime <= endDate.getTime()) {
    const randomValue = (
      Math.random() * (maxValue - minValue) +
      minValue
    ).toFixed(2); // 지정된 범위 내 랜덤 값
    data.push([currentTime, parseFloat(randomValue)]);
    currentTime += intervalHours * 60 * 60 * 1000; // 시간 간격 추가
  }

  return data;
}
